console.log('Rain Tree');

// Swiperをインポート
//import Swiper, { Navigation, Pagination, Autoplay, Thumbs, EffectFade } from 'swiper';
//import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

//Swiper.use([Thumbs]);

document.addEventListener('DOMContentLoaded', () => {
    /*
    * 変数
    */

    // 上部へ戻るボタン
    const toTopButton = document.querySelector('.to_top');

    // フッター追従バナー閉じるボタン
    const bannerCloseButton = document.querySelector('.p-top-banner__close');

    // TOPローディング
    const loadingScreen = document.querySelector('.loading-screen');

    /*
    * TOPページ：ローディングアニメーション
    */
    if (loadingScreen) {
        const firstViewImage = document.querySelector('.js-top-mv');
        const mainContent = document.querySelector('#wrapper');

        const minLoadingTime = 1000; // 最低1秒ローディング表示
        const startTime = Date.now(); // ローディング開始時間

        // ローディング画面をフェードイン
        loadingScreen.classList.add('visible');

        const hideLoadingScreen = () => {
            const elapsedTime = Date.now() - startTime; // 経過時間を計算
            const delay = Math.max(minLoadingTime - elapsedTime, 0); // 必要な遅延時間を計算

            setTimeout(() => {
                // ローディング画面をフェードアウト
                loadingScreen.classList.remove('visible');

                // 完全に非表示になるまで待機（フェードアウト時間に合わせる）
                setTimeout(() => {
                    loadingScreen.style.display = 'none'; // 完全にDOMから除外（任意）
                }, 500);

                // フェードアウト後にメインコンテンツを表示
                setTimeout(() => {
                    mainContent.classList.add('visible'); // フェードイン
                }, 500); // 0.5秒待機してフェードイン
            }, delay);
        };

        // ファーストビュー画像の読み込み完了時にローディング画面を隠す
        firstViewImage.onload = hideLoadingScreen;

        // キャッシュ済み画像の場合にも対応
        if (firstViewImage.complete) {
            hideLoadingScreen();
        }


    }

    // スクロールイベントを監視
    window.addEventListener('scroll', () => {
        // 1画面分スクロールしたら表示
        if (window.scrollY > window.innerHeight) {
            if (!(bannerCloseButton && bannerCloseButton.offsetParent !== null)) {
                toTopButton.classList.add('active');
            }
        } else {
            toTopButton.classList.remove('active');
        }
    });


    /*
    * TOPページ：MV下ピックアップバナーのスライド
    */

    const swiper_pickup_banner = new Swiper('.p-top-pickup-banner__slider', {
        //modules: [Navigation, Pagination, Autoplay],
        loop: true,
        slidesPerView: "auto", // 3枚表示
        centeredSlides: true, // 中央をアクティブにする
        centerInsufficientSlides: true, // スライド数が少ない場合でも中央に配置
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.p-top-pickup-banner__dots',
            clickable: true,
        },
        navigation: {
            nextEl: '.p-top-pickup-banner__next',
            prevEl: '.p-top-pickup-banner__prev',
        },
        spaceBetween: 40,
        breakpoints: {
            1024: {
                spaceBetween: 0, // 768px以上の画面幅ではスライド間のスペースを16pxに
            },
        }
    });

    /*
    * TOPページ：Movieのスライド
    */

    const swiper_movie = new Swiper('.p-top-movie__slider', {
        //modules: [Navigation, Autoplay],
        loop: true,
        slidesPerView: "auto", // 自動でスライド幅を決定
        centeredSlides: true, // 中央をアクティブにする
        loopAdditionalSlides: 1, // ループの余分なスライドを指定
        watchSlidesProgress: true,
        centerInsufficientSlides: true, // スライド数が少ない場合でも中央に配置
        spaceBetween: 16, // スライド間のスペース
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.p-top-movie__next',
            prevEl: '.p-top-movie__prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 1, // 768px以上の画面幅ではスライド間のスペースを16pxに
                spaceBetween: 40, // スライド間のスペース
            },
        }
    });

    /*
    * Memberページ：メンバーごとのスライド
    */

    document.querySelectorAll('.member').forEach((memberElement) => {
        // 各メンバー要素のIDを取得
        const memberId = memberElement.id;

        // サムネイルスライダーのクラスを取得してSwiper初期化
        const thumbSliderElement = memberElement.querySelector('.member__thumbnail');
        const thumbSwiper = new Swiper(thumbSliderElement, {
            slidesPerView: "auto",
        });

        // メインスライダーのクラスを取得してSwiper初期化
        const mainSliderElement = memberElement.querySelector('.member__slider');
        new Swiper(mainSliderElement, {
            //modules: [Thumbs, EffectFade],
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            speed: 400,
            thumbs: {
                swiper: thumbSwiper,
            },
        });
    });


    /*
    ** TOPページバナー
    */


    // 閉じるボタンが存在する場合のみイベントリスナーを追加
    if (bannerCloseButton) {
        bannerCloseButton.addEventListener('click', () => {
            // バナー要素を取得
            const banner = document.querySelector('.p-top-banner');
            if (banner) {
                banner.style.display = 'none'; // バナーを非表示にする
            }
            setTimeout(function () {
                if (window.scrollY > window.innerHeight) {
                    toTopButton.classList.add('active');
                }
            }, 2000)
        });
    }

    /*
    ** youtubeモーダル
    */

    // サムネイルリンクを取得
    const youtubeThumbnails = document.querySelectorAll('.js-movie');
    const modal = document.querySelector('.movie-modal');
    const modalVideoContainer = modal.querySelector('.movie-modal__video');
    const modalCloseButton = modal.querySelector('.movie-modal__close');

    // サムネイルのクリックイベントを設定
    youtubeThumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', (e) => {
            e.preventDefault(); // デフォルトのリンク動作を無効化

            // 動画IDを取得し、iframe用のURLを生成
            const videoId = thumbnail.getAttribute('data-src');
            const videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

            // iframe要素を作成
            const iframe = document.createElement('iframe');
            iframe.src = videoUrl;
            iframe.title = "YouTube video player";
            iframe.frameBorder = "0";
            iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
            iframe.allowFullscreen = true;

            // 動画コンテナにiframeを追加
            modalVideoContainer.appendChild(iframe);

            // モーダルを表示
            modal.classList.add('is-open');
        });
    });

    // クローズボタンのイベントを設定
    modalCloseButton.addEventListener('click', () => {
        // モーダルを非表示にし、iframeを削除して再生を停止
        modal.classList.remove('is-open');
        modalVideoContainer.innerHTML = ''; // iframeを削除
    });

    // モーダル外のクリックで閉じる処理
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            // モーダルを非表示にし、iframeを削除して再生を停止
            modal.classList.remove('is-open');
            modalVideoContainer.innerHTML = ''; // iframeを削除
        }
    });

    /*
    ** ハンバーガーメニュー
    */

    const headerMenu = document.querySelector('.header__menu');
    const bgDom = document.querySelector('.m-background');
    const logoDom = document.querySelector('.header__logo');
    const htmlElement = document.documentElement; // <html>要素を取得

    // .header__menuのクリックイベントを設定
    headerMenu.addEventListener('click', () => {
        htmlElement.classList.toggle('nav-open');
        bgDom.classList.toggle('nav-open');
        logoDom.classList.toggle('nav-open');
    });

    /*
    ** ios背景固定
    */

    function setViewportHeight() {
        // ビューポートの高さを取得し、--vhのカスタムCSSプロパティに設定
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        // 背景の高さも再度セット
        const backgroundElement = document.querySelector('.m-background');
        if (backgroundElement) {
            backgroundElement.style.height = `calc(var(--vh) * 100)`;
        }
    }

    // 初期設定
    setViewportHeight();

    // リサイズイベントで常に高さを再設定
    window.addEventListener('resize', setViewportHeight);

    // スクロールイベントでURLバーが変化する度に高さを再設定
    window.addEventListener('scroll', setViewportHeight);

    /*
    ** 上部に戻る
    */

    // クリックイベントを追加
    toTopButton.addEventListener('click', function () {
        // スムーズスクロールで最上部へ移動
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    /*
    ** アンカーリンク
    */

    // ページ内アンカーリンクのスムーズスクロール処理
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            // 対象リンクのハッシュ部分を取得
            const targetId = this.getAttribute('href');

            // ページ最上部に戻るボタンの場合は別の処理で対応
            if (targetId === '#top' || targetId === '#') {
                return; // `#top` などのリンクの場合は無視して既存の処理に任せる
            }

            // デフォルトのジャンプ処理を無効にする
            e.preventDefault();

            // 特殊文字を含むIDをエスケープし、先頭のバックスラッシュを削除
            let escapedTargetId = CSS.escape(targetId);
            if (escapedTargetId.startsWith('\\#')) {
                escapedTargetId = `#${escapedTargetId.slice(2)}`; // 先頭のバックスラッシュを削除
            }

            // スクロール対象の要素を取得
            const targetElement = document.querySelector(escapedTargetId);

            if (targetElement) {
                // スムーズスクロールでターゲット要素に移動
                window.scrollTo({
                    top: targetElement.offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });

});

